'use client';
import { useState } from 'react';
 import HeaderMenuItem from'./HeaderMenuItem';

const HeaderMenu = () => {
  const [activeItem, setActiveItem] = useState('Home')

  const menuItems = [
    { label: 'Home', href: '/' },
    { label: 'Events', href: '/#events' },
    { label: 'Speakers', href: '/#speakers' },
    { label: 'Event Highlights', href: '/#event-highlights' },
    { label: 'About Us', href: '/#about' },
    { label: 'Partners', href: '/#partners' }
  ]

  return (
    <nav data-component-id="src/components/common/HeaderMenu.tsx:18:4" data-component-path="src/components/common/HeaderMenu.tsx" data-component-line="18" data-component-file="HeaderMenu.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22flex%20flex-col%20lg%3Aflex-row%20items-center%20gap-4%20lg%3Agap-%5B32px%5D%20z-100%22%7D" className="flex flex-col lg:flex-row items-center gap-4 lg:gap-[32px] z-100" role="menubar">
      {menuItems.map((item) => (
        <HeaderMenuItem data-component-id="src/components/common/HeaderMenu.tsx:20:8" data-component-path="src/components/common/HeaderMenu.tsx" data-component-line="20" data-component-file="HeaderMenu.tsx" data-component-name="HeaderMenuItem" data-component-content="%7B%22elementName%22%3A%22HeaderMenuItem%22%7D"
          key={item.label}
          label={item.label}
          href={item.href}
          isActive={activeItem === item.label}
          onClick={() => setActiveItem(item.label)}
        />
      ))}
    </nav>
  )
}

export default HeaderMenu